import { render, staticRenderFns } from "./add-release-authorization.component.vue?vue&type=template&id=6881fbde&"
import script from "./add-release-authorization.component.vue?vue&type=script&lang=ts&"
export * from "./add-release-authorization.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports